import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import humanTime from 'flarum/common/helpers/humanTime';
import driverName from '../../common/utils/driverName';
/**
 * "Claude · 3 minutes ago" line under a translation.
 */
export default class TranslationMeta extends Component {
  view() {
    const {
      provider,
      updatedAt
    } = this.attrs;
    if (!provider) return null;
    const providerLabel = driverName(provider);
    return m("div", {
      className: "TranslationMeta"
    }, updatedAt ? app.translator.trans('fof-translate.forum.translation.meta', {
      provider: providerLabel,
      time: humanTime(updatedAt)
    }) : providerLabel);
  }
}
flarum.reg.add('fof-translate', 'forum/components/TranslationMeta', TranslationMeta);